import React from "react";

export function Basecamp({ size }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 3.17 511.025 501.76" width={size + "px"} height={size + "px"}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M54.491 216.137c31.94-90.21 92.892-195.047 215.894-195.047S454.217 182.857 461.897 292.57"
          stroke="#1d2d35"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={41.57}
        />
        <path
          d="M511.025 354.011L144.579 504.93 0 154.088l66.072-27.307L366.446 3.17z"
          fill="#ffe000"
          fillRule="nonzero"
          opacity={0.4}
        />
        <path
          d="M493.836 393.752l-388.023 80.214-76.922-371.688 65.22-13.531 322.925-66.682z"
          fill="#ffe000"
          fillRule="nonzero"
        />
        <path
          d="M270.385 20.846c123.002 0 183.832 162.011 191.512 271.725-32.305 56.077-109.714 77.166-191.512 77.166a230.034 230.034 0 0 1-176.153-77.166s38.522-103.984 74.484-104.228c26.332 0 48.762 48.762 69.852 48.762s64.853-93.623 64.853-93.623"
          stroke="#1d2d35"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={41.57}
        />
      </g>
    </svg>
  );
}
